<template>
  <!-- 直播倒计时 -->
  <div class="supply_topic_btn">
    <div class="btn_wrap" :class="tabName=='supply'?'supply_wrap':'topic_wrap'">
      <img src="@/assets/img/new/supply_ic.png" @click="goTo" v-if="tabName=='supply'" />
      <img src="@/assets/img/new/topic_ic.png" @click="goTo" v-else />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "my-supply-topic-btn",
  props: {
    tabName: {
      type: String,
      default: "supply",
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      userInfo:"getUserInfo"
    }),
  },
  created() {},
  methods: {
    ...mapActions({
      LinkHotPub: "linkTo/LinkHotPub", //话题
      LinkHotSupply: "linkTo/LinkHotSupply", //供需
    }),
    goTo() {
      if (this.userInfo.inMember.userRole.toUpperCase() == "VISITOR") {
        this.$Myapollo.unverifiedDialog(this,true);
        return;
      }
      if (this.tabName == "supply") {
        this.LinkHotSupply();
      } else {
        localStorage.removeItem('content');
        localStorage.removeItem('relepase');
        localStorage.removeItem('Upimg');
        this.LinkHotPub({ id: false, talkId: false });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.supply_topic_btn {
  .btn_wrap {
    z-index: 199;
    position: fixed;
    bottom: 1rem;
    right: 0.3rem;
    width: 1rem;
    height: 1rem;
    overflow: hidden;
    border-radius: 50%;
    &.supply_wrap {
      box-shadow: 0 0.05rem 0.1rem 0 rgba(255, 92, 0, 0.4);
    }
    &.topic_wrap {
      box-shadow: 0 0.05rem 0.1rem 0 rgba(1, 44, 126, 0.4);
    }
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
</style>
